import { Notification } from 'notification/notification';
import React, { useEffect, useState } from 'react';
import { useCallback } from 'react';
import { useTable } from 'react-table';
import {
  Button,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap';
import { handleSendGeneric } from 'services/generic';
import { TableGenericClients } from '../Client/clients';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

export const columnsCity = [
  {
    Header: 'Nome',
    accessor: 'name',
  },
  {
    Header: 'Estado',
    accessor: 'state',
  },
  {
    Header: 'QTD. Clientes',
    accessor: 'clients',
    Cell: ({ ...props }) => {
      const city = props.data[props.row.index];
      return <span>{city?.clients?.length}</span>;
    },
  },
];

export const columnsClient = [
  {
    Header: 'Razão Social',
    accessor: 'name',
  },
  {
    Header: 'Cidade',
    accessor: 'city',
  },
  {
    Header: 'Estado',
    accessor: 'state',
  },
];

export const TableCity = React.memo(({ data }) => {
  const [tableData, setTableData] = useState(data);
  const { id } = useParams();

  const handleDeleteCityOnRoute = (route) => {
    const payload = {
      routeId: id,
      action: 'DELETE',
      name: route?.name,
      state: route?.state,
    };
    handleSendGeneric(`/v1/route/action`, 'POST', payload);
    Notification(200);
    window.location.reload();
  };

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns: [
        ...columnsCity,
        {
          Header: 'Ação',
          Cell: ({ ...props }) => {
            const [modal, setModal] = useState(false);

            const toggle = (e) => {
              e.preventDefault();
              setModal(!modal);
            };

            return (
              <>
                <Button color='danger' onClick={() => setModal(true)}>
                  Desvincular
                </Button>
                <Modal isOpen={modal} size='md' fade={false}>
                  <ModalBody>Deseja realmente desvincular este item?</ModalBody>
                  <ModalFooter>
                    <Button
                      color='danger'
                      onClick={() =>
                        handleDeleteCityOnRoute(props.data[props.row.index])
                      }
                      size='lg'
                    >
                      Desvincular
                    </Button>
                    <Button
                      color='secondary'
                      onClick={(e) => toggle(e)}
                      size='lg'
                    >
                      Fechar
                    </Button>
                  </ModalFooter>
                </Modal>
              </>
            );
          },
        },
      ],
      data: tableData,
    });

  const updateTableData = useCallback((newData) => {
    setTableData(newData);
  }, []);

  useEffect(() => {
    updateTableData(data);
  }, [data, updateTableData]);

  return (
    <>
      <Table responsive hover {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  scope='col'
                  {...column.getHeaderProps()}
                  style={{ textAlign: 'center' }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map((row, i) => {
              prepareRow(row);
              return <Description row={row} key={i} />;
            })
          ) : (
            <tr>
              <td
                colSpan='7'
                style={{ textAlign: 'center', width: '20px', fontSize: '14px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '14px',
                    alignItems: 'center',
                  }}
                >
                  Sem registros de cidades na rota!
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </>
  );
});

const Description = ({ row }) => {
  const [open, setOpen] = useState(true);
  const [city, setCity] = useState(row?.original);
  const [showModal, setShowModal] = useState(false);

  const handleIncludeDeleteClientOnRoute = (client) => {
    const payload = {
      clientId: client?.id,
      action: 'DELETE',
      cityId: city.id,
    };
    handleSendGeneric(`/v1/city/action`, 'POST', payload);
    let newClient = city.clients.filter((cl) => cl.id !== client?.id);
    Notification(200);
    setCity({ ...city, clients: newClient });
  };

  const updateStateOpen = (e) => {
    if (e.target.value !== undefined) {
      return;
    }
    e.preventDefault();
    setOpen(!open);
  };

  return open ? (
    <tr
      style={{ textAlign: 'center' }}
      {...row.getRowProps()}
      onClick={updateStateOpen}
    >
      {row.cells.map((cell) => {
        return (
          <td style={{ textAlign: 'center' }} {...cell.getCellProps()}>
            {cell.render('Cell')}
          </td>
        );
      })}
    </tr>
  ) : (
    <>
      <tr
        style={{ textAlign: 'center' }}
        {...row.getRowProps()}
        onClick={updateStateOpen}
      >
        {row.cells.map((cell) => {
          return (
            <td style={{ textAlign: 'center' }} {...cell.getCellProps()}>
              {cell.render('Cell')}
            </td>
          );
        })}
      </tr>
      <tr>
        <td colSpan='100%'>
          <>
            <CardHeader className='border-0'>
              <Row className='align-items-center'>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                  className='col'
                >
                  <h3 className='mb-0'>Clientes Vinculados</h3>
                  <Button
                    color='primary'
                    size='md'
                    onClick={() => setShowModal(true)}
                  >
                    Vincular
                  </Button>
                  <ModalClient
                    showModal={showModal}
                    setShowModal={setShowModal}
                    city={row?.original}
                  />
                </div>
              </Row>
            </CardHeader>
            <TableGenericClients
              disableGlobalFilter={true}
              columns={[
                ...columnsClient,
                {
                  Header: 'Ação',
                  Cell: ({ ...props }) => {
                    const [modal, setModal] = useState(false);

                    const toggle = (e) => {
                      e.preventDefault();
                      setModal(!modal);
                    };

                    return (
                      <>
                        <Button color='danger' onClick={() => setModal(true)}>
                          Desvincular
                        </Button>
                        <Modal isOpen={modal} size='md' fade={false}>
                          <ModalBody>
                            Deseja realmente desvincular este item?
                          </ModalBody>
                          <ModalFooter>
                            <Button
                              color='danger'
                              onClick={() =>
                                handleIncludeDeleteClientOnRoute(
                                  props.data[props.row.index]
                                )
                              }
                              size='lg'
                            >
                              Desvincular
                            </Button>
                            <Button
                              color='secondary'
                              onClick={(e) => toggle(e)}
                              size='lg'
                            >
                              Fechar
                            </Button>
                          </ModalFooter>
                        </Modal>
                      </>
                    );
                  },
                },
              ]}
              data={city?.clients}
            />
          </>
        </td>
      </tr>
    </>
  );
};

const ModalClient = ({ showModal, setShowModal, city }) => {
  const [clientsToInclude, setClientesToInclude] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const data = await handleSendGeneric(`/v1/client`, 'GET');
    setClientesToInclude(data);
  }, []);

  const handleIncludeNewClientOnRoute = (idClient) => {
    const payload = {
      clientId: idClient,
      action: 'CREATE',
      cityId: city?.id,
    };
    handleSendGeneric(`/v1/city/action`, 'POST', payload);
    Notification(200);
  };

  return (
    <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
      <ModalHeader toggle={() => setShowModal(false)}>
        Clientes para Vincular
      </ModalHeader>
      <ModalBody style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <TableGenericClients
          columns={[
            {
              Header: 'Razão Social',
              accessor: 'name',
            },
            {
              Header: 'Cidade',
              accessor: 'city',
            },
            {
              Header: 'Estado',
              accessor: 'state',
            },
            {
              Header: 'Ação',
              Cell: ({ ...props }) => {
                const actionId = props.data[props.row.index]?.id;
                return (
                  <Button
                    color='success'
                    onClick={() => handleIncludeNewClientOnRoute(actionId)}
                  >
                    Vincular
                  </Button>
                );
              },
            },
          ]}
          data={clientsToInclude}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => {
            setShowModal(false);
            window.location.reload();
          }}
        >
          Salvar Alterações
        </Button>{' '}
        <Button
          color='secondary'
          onClick={() => {
            setShowModal(false);
          }}
        >
          Sair
        </Button>
      </ModalFooter>
    </Modal>
  );
};
